import { createContext, type ReactNode } from "react";
export const ShellCommentsContext = createContext<ReactNode>(undefined);
